import { useContext, useState } from 'react';
import { GiftCardContext } from '../../context/GiftCardContext';
import GiftcardModal from '../../pages/modals/GiftcardModal';
//@ts-ignore
import { ReactComponent as GiftCardSvg } from '../../assets/gogift.svg';
import './giftcard.scss';

const Giftcard = (): JSX.Element => {
    const { showGiftCard, data, strings } = useContext(GiftCardContext);
    const [showDetails, setShowDetails] = useState<boolean>(false);

    const showGiftcardDetails = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        setShowDetails(true);
    };

    return showGiftCard ? (
        <>
            <div
                className={`giftcard-container ${
                    data.campaign === 'blackweek'
                        ? 'giftcard-container-campaign-blackweek'
                        : 'giftcard-container-campaign-default'
                }`}
            >
                <div className="giftcard-logo">
                    {data.campaign === 'blackweek' ? (
                        <img src={require('../../assets/gogift.png')} width={100} alt="GoGift Logo" />
                    ) : (
                        <GiftCardSvg />
                    )}
                </div>
                <div className="giftcard-inner-container">
                    <div className="giftcard-text">
                        <div className="giftcard-text-header">
                            {strings['intro.header'].replace('{amount}', data.amount)} {data.key === 'child' ? '*' : ''}
                        </div>
                        <div style={{ paddingTop: '15px' }}>
                            {strings['intro.text'].replace('{amount}', data.amount)}
                        </div>
                        {data.key === 'child' ? (
                            <div style={{ paddingTop: '15px', fontSize: '12px', lineHeight: '16px' }}>
                                {strings[`intro.footer.${data.key}`]}
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                    <div
                        className={
                            data.campaign === 'blackweek'
                                ? 'giftcard-more-info-blackweek'
                                : 'giftcard-more-info-default'
                        }
                    >
                        <a
                            href="/"
                            title="Info"
                            onClick={(e) => showGiftcardDetails(e)}
                            data-testid="giftcard-show-details-link"
                        >
                            Info
                        </a>
                    </div>
                </div>
            </div>

            <GiftcardModal
                show={showDetails}
                strings={strings}
                amount={data.amount}
                closeHandler={() => setShowDetails(false)}
                data-testid="giftcard-modal"
            />
        </>
    ) : (
        <></>
    );
};

export { Giftcard };
